export const globalMappingStatus = {}
export const globalRefiningStatus = {}
